module.exports = __webpack_public_path__ + "static/media/TUIG.b9c002fe.png";